(function() {
  // Function to find and manage the rewards button
  function setupRewardsButtonVisibility() {
    // Get references to the cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    
    // Function to check for the rewards button (it might load dynamically)
    function findRewardsButton() {
      // Try multiple selectors to ensure we catch it
      return document.getElementById('ew-btn-kr') || 
             document.querySelector('div[id="ew-btn-kr"]') || 
             document.querySelector('.ew-btn-kr') || 
             document.querySelector('.launcher-kr') || 
             document.querySelector('div[data-v-18281b42][id="kr-widget-launcher-button"]');
    }
    
    // Function to hide the rewards button
    function handleRewardsButtonVisibility() {
      const rewardsButton = findRewardsButton();
      if (!rewardsButton) return;
      
      const isCartActive = cartDrawer.classList.contains('active');
      if (isCartActive) {
        rewardsButton.style.display = 'none';
      } else {
        rewardsButton.style.display = '';
      }
    }
    
    // Watch for cart drawer class changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleRewardsButtonVisibility();
        }
      });
    });
    
    observer.observe(cartDrawer, { attributes: true });
    
    // Also listen for cart drawer open/close events
    cartDrawer.addEventListener('transitionend', handleRewardsButtonVisibility);
    
    // Handle initial state
    handleRewardsButtonVisibility();
    
    // Check periodically for the rewards button in case it loads after our script
    const checkInterval = setInterval(() => {
      const rewardsButton = findRewardsButton();
      if (rewardsButton) {
        handleRewardsButtonVisibility();
        clearInterval(checkInterval);
      }
    }, 500);
    
    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupRewardsButtonVisibility);
  } else {
    setupRewardsButtonVisibility();
  }
  
  // Also run when page is fully loaded (for dynamically added elements)
  window.addEventListener('load', setupRewardsButtonVisibility);
})();
